import type { ThemeConfig } from "antd";

export const VLLoader_SPIN_THEMES = {
  default: {
    components: {
      Spin: {
        colorPrimary: "var(--new-neutral-600)",
      },
    },
  },
  light: {
    components: {
      Spin: {
        colorPrimary: "var(--primary-color-4)",
      },
    },
  },
} as const satisfies Record<string, ThemeConfig>;

export type VLLoaderThemeType = keyof typeof VLLoader_SPIN_THEMES;
